import apiClient from '@u/apiClient'
import CreateModelActivityController from '@/wayfinder/actions/App/Http/Controllers/ModelActivity/CreateModelActivityController'

let base_errors = { deceased: {}, events: [] }

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  addModelActivity({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateModelActivityController.post(), payload.activity)
        .then((response) => {
          resolve(response.data)
          if (response.data.metadata) {
            commit('invoicing/setInvoiceMetadata', response.data.metadata, {
              root: true
            })
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
